import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';

const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    search.set(k, v);
  });
  const str = search.toString();
  return str ? `?${str}` : '';
};

// Labels & rule sets
export const listPricingLabels = () => apiGet('/api/admin/pricing/labels');
export const createPricingLabel = (payload) => apiPost('/api/admin/pricing/labels', payload);
export const updatePricingLabel = (id, payload) => apiPut(`/api/admin/pricing/labels/${id}`, payload);
export const deletePricingLabel = (id) => apiDelete(`/api/admin/pricing/labels/${id}`);

export const listRuleSets = () => apiGet('/api/admin/pricing/rule-sets');

// Seasonal pricing
export const listSeasonalRules = (params = {}) => apiGet(`/api/admin/pricing/seasonal${qs(params)}`);
export const createSeasonalRule = (payload) => apiPost('/api/admin/pricing/seasonal', payload);
export const updateSeasonalRule = (id, payload) => apiPut(`/api/admin/pricing/seasonal/${id}`, payload);
export const deleteSeasonalRule = (id) => apiDelete(`/api/admin/pricing/seasonal/${id}`);
export const toggleSeasonalRule = (id, is_active) => apiPost(`/api/admin/pricing/seasonal/${id}/toggle`, { is_active });

// Special offers
export const listOfferRules = (params = {}) => apiGet(`/api/admin/pricing/offers${qs(params)}`);
export const createOfferRule = (payload) => apiPost('/api/admin/pricing/offers', payload);
export const updateOfferRule = (id, payload) => apiPut(`/api/admin/pricing/offers/${id}`, payload);
export const deleteOfferRule = (id) => apiDelete(`/api/admin/pricing/offers/${id}`);
export const toggleOfferRule = (id, is_active) => apiPost(`/api/admin/pricing/offers/${id}/toggle`, { is_active });

// Taxes & fees
export const listTaxFeeRules = (params = {}) => apiGet(`/api/admin/pricing/taxes-fees${qs(params)}`);
export const createTaxFeeRule = (payload) => apiPost('/api/admin/pricing/taxes-fees', payload);
export const updateTaxFeeRule = (id, payload) => apiPut(`/api/admin/pricing/taxes-fees/${id}`, payload);
export const deleteTaxFeeRule = (id) => apiDelete(`/api/admin/pricing/taxes-fees/${id}`);
export const toggleTaxFeeRule = (id, is_active) => apiPost(`/api/admin/pricing/taxes-fees/${id}/toggle`, { is_active });
export const previewTaxFeeQuote = (payload) => apiPost('/api/admin/pricing/taxes-fees/preview', payload);

export const previewQuote = (payload) => apiPost('/api/public/pricing/quote', payload);
